import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

//image
// import SlowImg1 from '../../assets/img/route-104-slow-img1.png';
import SlowImg1 from '../../assets/img/route-103-slow-img1.png';
// import SlowImg1Eng from '../../assets/img/route-104-slow-img1-eng.png';
import SlowImg1Eng from '../../assets/img/route-103-slow-img1-eng.png';

const Slow = ({language}) => {
    return (
        <section className="route104-slow">
            <h5><span>{language === "Chinese" ? "坡度圖" : "Elevation Profile"}</span></h5>
            <Container>
                <Row className='align-items-center'>
                    <Col md={12} className='mt-5 mb-5'>
                        {language === "Chinese" ? <img src={SlowImg1} alt="坡度圖" /> : <img src={SlowImg1Eng} alt="Elevation profile" /> }
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Slow